angular.module('shared').factory('CwStorage', function() {
  var Storage, data, error, hasLocalStorage, x;
  data = {};
  hasLocalStorage = false;
  try {
    x = 'testStorage';
    localStorage.setItem(x, x);
    localStorage.removeItem(x);
    hasLocalStorage = true;
  } catch (error1) {
    error = error1;
    hasLocalStorage = false;
  }
  Storage = {
    setItem: function(key, value) {
      if (hasLocalStorage) {
        return localStorage.setItem(key, value);
      } else {
        return data[key] = value;
      }
    },
    getItem: function(key) {
      if (hasLocalStorage) {
        return localStorage.getItem(key);
      } else {
        return data[key] || 'null';
      }
    },
    removeItem: function(key) {
      if (hasLocalStorage) {
        return localStorage.removeItem(key);
      } else {
        return data[key] = null;
      }
    },
    clear: function() {
      if (hasLocalStorage) {
        return localStorage.clear();
      } else {
        return data = {};
      }
    }
  };
  return Storage;
});
